import { IBrandLead } from '../../indigofair/data/IBrandLead';

export namespace ICreateBrandLeadRequest {
  /**
   * Return an instance of ICreateBrandLeadRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ICreateBrandLeadRequest>
  ): ICreateBrandLeadRequest =>
    ({
      ...(partial ?? {}),
    }) as ICreateBrandLeadRequest;
}

export interface ICreateBrandLeadRequest {
  brand_lead: IBrandLead | undefined;
  salesforce_user_id: string | undefined;
  is_update_to_lead_allowed: boolean | undefined;
  term_of_service_accepted: boolean | undefined;
  /**
   * Used for linking brand inbound applications in shop-integration for Shopify Sales Channel app installs
   */
  temporary_pos_link_key: string | undefined;
}
